import { render } from "./FormPendaftaran.vue?vue&type=template&id=19ca90b3&scoped=true"
import script from "./FormPendaftaran.vue?vue&type=script&lang=js"
export * from "./FormPendaftaran.vue?vue&type=script&lang=js"

import "./FormPendaftaran.vue?vue&type=style&index=0&id=19ca90b3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ca90b3"]])

export default __exports__